import React, { useState, useEffect } from 'react';
import { List,Button,Toast,Modal} from 'antd-mobile';
import { leaveInfo as leaveInfoReq, updateLeaveStatus} from '../../../../services/saas/oa';
import { useParams } from 'react-router';
import { getUser } from '../../../../utils';

const Item = List.Item;

function AuditDetail(props) {
  const locationParam = useParams();
  const { leaveId:id }  = locationParam;
  const [leaveInfo,setLeaveInfo] = useState({});
  const { userId } = getUser();

  const getLeaveInfo = async function () {
    const response = await leaveInfoReq({ id });
    if (response&&response.success && response.data) {
      setLeaveInfo(response.data);
    }
  }

  useEffect(()=>{
    getLeaveInfo();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  //审核通过
  const clickPassBtn = () => {
    Modal.alert('请假审核', '确定通过吗?', [
      { text: '取消', onPress: () => console.log('cancel') },
      {
        text: '通过',
        onPress: async () =>{
          const params = {
            id,
            leaveFormStatus: 3,
            operator:userId
          };
          const response = await updateLeaveStatus(params);
          if (response&&response.success) {
             Toast.fail('审核通过');
             window.history.go(-1);
            //  history.refresh(`${preRouteUrl}/oa/leave`);
          }else{
             Toast.fail('提交失败');
          }
        }
      },
    ])
  };

  //审核驳回
  const clickNoPassBtn = () => {
    Modal.prompt('请假驳回', '请输入驳回原因', [
      { text: '取消' },
      { text: '提交', onPress: async value => {
          console.log(`输入的内容:${value}`);
          const params = {
                id,
                leaveFormStatus: 2,
                operator:userId,
                remark:value
          }
          const response = await updateLeaveStatus(params);
          if (response&&response.success) {
             Toast.fail('提交成功');
             window.history.go(-1);
            //  history.refresh(`${preRouteUrl}/oa/leave`)
          }else{
             Toast.fail('提交失败');
          }
        }
      },
    ], 'default', '')
  };

  return (
    <div className="leave-detail">
      <List>
        <Item>
          <div>
            <label>姓名</label>
            <span className="lText">{leaveInfo.userName}</span>
          </div>
        </Item>
        <Item>
          <div>
            <label>用户类型</label>
            <span className="lText">{leaveInfo.userTypeName}</span>
          </div>
        </Item>
        <Item>
          <div>
            <label>机构</label>
            <span className="lText">{leaveInfo.deptName}</span>
          </div>
        </Item>
        <Item>
          <div>
            <label>电话</label>
            <span className="lText">{leaveInfo.phone}</span>
          </div>
        </Item>
        <Item>
          <div>
            <label>请假类型</label>
            <span className="lText">{leaveInfo.typeName}</span>
          </div>
        </Item>
        <Item>
          <div>
            <label>申请时间</label>
            <span className="lText">{leaveInfo.applyTime}</span>
          </div>
        </Item>
        <Item>
          <div>
            <label>开始时间</label>
            <span className="lText">{leaveInfo.startTime}</span>
          </div>
        </Item>
        <Item>
          <div>
            <label>结束时间</label>
            <span className="lText">{leaveInfo.endTime}</span>
          </div>
        </Item>
        <Item>
          <div>
            <label>请假原因</label>
            <div className="lText reason">{leaveInfo.reason}</div>
          </div>
        </Item>
        {/* <Item>
          <div className='leave-detail-file'>
            <label>附件</label>
            <div>
              <ul>
                {
                  leaveInfo.leaveAttachmentList ?(
                      leaveInfo.leaveAttachmentList.map((item,index) => (
                        <li key={index} className='line-limit-length'>
                          {index+1}. {item.attachmentName}
                        </li>
                      ))
                  ) : ''
                }
              </ul>
            </div>
          </div>
        </Item> */}
      </List>
      {
        leaveInfo.leaveFormStatus===1?(
          <div className="leaveBtn">
            <Button type="primary" inline style={{ marginRight: '30px' }} onClick={() => clickPassBtn()}>通过</Button>
            <Button type="warning" inline onClick={() => clickNoPassBtn()}>驳回</Button>
          </div>
        ):null
      }



    </div>
  );
}

export default AuditDetail;


